import { render, staticRenderFns } from "./WorkflowReview.vue?vue&type=template&id=222a316b&scoped=true"
import script from "./WorkflowReview.vue?vue&type=script&lang=js"
export * from "./WorkflowReview.vue?vue&type=script&lang=js"
import style0 from "./WorkflowReview.vue?vue&type=style&index=0&id=222a316b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222a316b",
  null
  
)

export default component.exports